import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalibrantLoadComponent } from './calibrant-load.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CalibrantLoadComponent
  ],
  exports: [
    CalibrantLoadComponent
  ]
})
export class CalibrantLoadModule { }
